"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  PantoneColors: true
};
Object.defineProperty(exports, "PantoneColors", {
  enumerable: true,
  get: function () {
    return _colorLibrary.pantone;
  }
});
exports.default = void 0;
var _acceptedColors = _interopRequireDefault(require("./accepted-colors"));
var _convertColor = _interopRequireDefault(require("./convert-color"));
var _colorLibrary = require("./color-library");
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class ColorConverter {
  constructor() {
    _defineProperty(this, "inputColorType", void 0);
    _defineProperty(this, "inputColorValue", void 0);
    _defineProperty(this, "outputColorValues", void 0);
    _defineProperty(this, "cmyk", void 0);
    _defineProperty(this, "hex3", void 0);
    _defineProperty(this, "hex6", void 0);
    _defineProperty(this, "hsl", void 0);
    _defineProperty(this, "hsv", void 0);
    _defineProperty(this, "lab", void 0);
    _defineProperty(this, "pantone", void 0);
    _defineProperty(this, "ral", void 0);
    _defineProperty(this, "rgb", void 0);
    _defineProperty(this, "xyz", void 0);
    _defineProperty(this, "yuv", void 0);
    // eslint-disable-next-line no-restricted-syntax
    for (const acceptedColor of _acceptedColors.default) {
      const defineProperty = colorKey => Object.defineProperty(this, colorKey, {
        enumerable: true,
        configurable: true,
        get() {
          if (!this.inputColorType) {
            if (acceptedColor === 'hex3' || acceptedColor === 'hex6') {
              return {
                value: ''
              };
            }
            if (acceptedColor === 'pantone') {
              return {
                name: ''
              };
            }
            if (acceptedColor === 'ral') {
              return {
                ral: 9010,
                name: 'PureWhite',
                lrv: 84
              };
            }
            return {};
          }
          if (this.inputColorType === acceptedColor) {
            return this.inputColorValue;
          }
          if (!this.outputColorValues[acceptedColor]) {
            this.outputColorValues[acceptedColor] = (0, _convertColor.default)({
              from: {
                type: this.inputColorType,
                value: this.inputColorValue
              },
              to: acceptedColor
            }); // eslint-disable-line @typescript-eslint/no-explicit-any
          }
          return this.outputColorValues[acceptedColor];
        },
        set(value) {
          if (!value) {
            throw new Error("Value can't be empty");
          }
          if (this.inputColorType !== acceptedColor || this.inputColorValue !== value) {
            this.inputColorType = acceptedColor;
            if (acceptedColor !== 'pantone' && acceptedColor !== 'ral') {
              this.inputColorValue = value;
            } else {
              this.inputColorValue = (0, _convertColor.default)({
                from: {
                  type: acceptedColor,
                  value
                },
                to: acceptedColor
              });
            }
            this.outputColorValues = {};
          }
        }
      });
      defineProperty(acceptedColor);
      if (acceptedColor === 'hex6') {
        defineProperty('hex');
      }
    }
  }
}
exports.default = ColorConverter;